import { Navigate, useLocation, useParams } from "react-router";

export function FeaturesToFlagsRedirect() {
  const { "*": splat } = useParams();
  const { search, hash } = useLocation();
  return (
    <Navigate
      to={`../flags${splat ? `/${splat}` : ""}${search}${hash}`}
      replace
    />
  );
}
